/**
 * MuiPickersPopper
 *
 * Demos:
 *
 * - [DatePicker](https://ui-packages.isbuildingluma.com/ui-core/react-date-picker/)
 */ // eslint-disable-next-line import/prefer-default-export
export const MuiPickersPopper = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      '.MuiPickersDay-root:focus.Mui-selected': {
        backgroundColor: theme.palette.primary.main
      },
      '.MuiPickersYear-yearButton:focus.Mui-selected': {
        backgroundColor: theme.palette.primary.main
      }
    })
  }
};